<template>
    <div>
        <sav-responsive-access-template :logo="$companyTool.confFile().style.logo">
            <!-- <div class="hidden py-4 text-white duration-200 default-bg-color md:block"></div> -->
            <div class="sticky top-0 z-10 py-2 md:py-5 text-white duration-200 shadow-lg menu-text-unselected default-bg-color">
                <div class="sticky top-0 z-10">
                    <div class="container px-6 py-2 mx-auto md:px-0 md:py-0">
                        <div class="md:flex items-center justify-center md:justify-between">
                            <div class="md:flex items-center">
                                <!-- logo -->
                                <template v-if="$companyTool.confFile()">
                                    <div class="flex items-center justify-between text-center md:text-left md:pr-10 md:mr-10 md:border-r" :class="!isConnected ? 'md:border-r-0' : ''">
                                        <router-link class="flex items-center" :to="{name: 'home'}">
                                            <div v-if="!$companyTool.confFile().style.logo">
                                                <h1 class="text-xl capitalize">{{$companyTool.keyname == 'default' ? 'SavInfo': $companyTool.confFile().name}}</h1>
                                                <div class="text-xs font-extralight menu-text-unselected">{{$companyTool.confFile().style.logo }}{{ $t("template.header.application_consommateur") }}</div>
                                            </div>
                                            <div class="flex gap-2 items-center justify-center md:justify-start" v-else>
                                                <img class="block header-logo-height" :src="$companyTool.confFile().style.logo" :alt="'logo ' + $companyTool.confFile().name">
                                                <div class="text-left">
                                                    <h1 v-if="!$companyTool.confFile().style.headerHideBrand" class="text-2xl capitalize default-text-selected" v-html="$companyTool.keyname == 'default' ? 'SavInfo': $companyTool.confFile().name"></h1>
                                                    <p v-if="$companyTool.confFile().slogan && $companyTool.confFile().slogan != 'null'" class="font-light text-sm default-text-selected">{{ $companyTool.confFile().slogan }}</p>
                                                </div>
                                            </div>
                                        </router-link>
                                        <!-- Lang mobile -->
                                        <div class="md:hidden mt-2">
                                            <dropdown-menu v-if="langage && $companyTool.confFile().translates" class="rounded-xl" :overlay="false" :transition="null" direction="right">
                                                <button slot="trigger" id="dropdownUser" class="focus:outline-none" type="button">
                                                    <img class="h-[15px]" :src="langage.logo" />
                                                </button>
                                                <div slot="body" class="text-center bg-white divide-y divide-gray-100 text-slate-500">
                                                    <div @click="changeLangage(lang.lang)" v-for="(lang, langIndex) in langs" :key="'select-lang-' + langIndex" class="p-2 hover:bg-slate-100 duration-200 cursor-pointer">
                                                        <img class="h-[15px] mx-auto" :src="lang.logo" />
                                                    </div>
                                                </div>
                                            </dropdown-menu>
                                        </div>
                                    </div>
                                </template>
                                <!-- Menu -->
                                <div v-if="isConnected" class="items-center hidden md:flex">
                                    <router-link :to="{ name: 'home' }" style="text-decoration: none">
                                        <div class="flex items-center mr-10 text-lg font-light duration-200 cursor-pointer" :class="isSelect('home') || isSelect('form') ? 'default-text-selected font-bold' : ''">
                                            <i class="mr-2 text-sm fas fa-home"></i>
                                            <span class="text-base">{{ $t("template.header.accueil") }}</span>
                                        </div>
                                    </router-link>
                                    <router-link :to="{ name: 'user.product.list' }" style="text-decoration: none">
                                        <div class="flex items-center mr-10 text-lg font-light duration-200 cursor-pointer" :class="isSelect('user.product.list') ? 'default-text-selected font-bold' : ''">
                                            <i class="mr-2 text-sm fas fa-clock-rotate-left"></i>
                                            <span class="text-base">{{ $t("template.header.mes_demandes") }}</span>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                            <!-- Header right section -->
                            <div class="hidden md:block">
                                <div class="flex items-center grow menu-text-unselected">
                                    <div class="flex items-center gap-4 mt-1">
                                        <!-- Account -->
                                        <dropdown-menu v-if="isConnected" class="rounded-xl" :overlay="false" :transition="null" direction="right">
                                            <button slot="trigger" id="dropdownUser" class="focus:outline-none" type="button">
                                                <div class=" rounded-full" style="
                                                background-image: url('https://disticloudfiles.net/upload/files/user.jpg');
                                                background-size: cover;
                                                background-position: center center;
                                                width: 30px;
                                                height: 30px;
                                                "></div>
                                            </button>
                                            <div slot="body" class="bg-white divide-y divide-gray-100">
                                                <div class="p-2">
                                                    <router-link :to="{ name: 'user.update'}" style="text-decoration: none">
                                                        <div class="py-2 text-center text-gray-600 cursor-pointer hover:text-gray-900">
                                                            {{$t('template.header.mon_compte')}}
                                                        </div>
                                                    </router-link>
                                                    <router-link :to="{ name: 'user.logout'}" style="text-decoration: none">
                                                        <div class="py-2 text-center text-gray-600 cursor-pointer hover:text-gray-900">
                                                            {{$t('template.header.deconnexion')}}
                                                        </div>
                                                    </router-link>
                                                </div>
                                            </div>
                                        </dropdown-menu>
                                        <!-- Lang -->
                                        <dropdown-menu v-if="langage && $companyTool.confFile().translates" class="rounded-xl" :overlay="false" :transition="null" direction="right">
                                            <button slot="trigger" id="dropdownUser" class="focus:outline-none" type="button">
                                                <img class="h-[15px]" :src="langage.logo" />
                                            </button>
                                            <div slot="body" class="text-center bg-white divide-y divide-gray-100 text-slate-500">
                                                <div @click="changeLangage(lang.lang)" v-for="(lang, langIndex) in langs" :key="'select-lang-' + langIndex" class="p-2 hover:bg-slate-100 duration-200 cursor-pointer">
                                                    <img class="h-[15px] mx-auto" :src="lang.logo" />
                                                </div>
                                            </div>
                                        </dropdown-menu>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container p-5 mx-auto md:p-12 sm:px-4">
                <div class="grid gap-10" :class="leftImage ? 'grid-cols-3' : 'grid-cols-8 xl:grid-cols-6'">
                    <div class="hidden" :class="leftImage ? 'col-span-1 lg:block' : ''">
                        <div
                        class="sticky top-28 rounded-xl animate__animated animate__fadeIn"
                        :style="'background-image: url(' + leftImage + ');'"
                        style="
                        height: 450px;
                        width: 100%;
                        background-position: center center;
                        background-size: cover"
                        ></div>
                    </div>
                    <div :class="leftImage ? 'col-span-3 lg:col-span-2' : 'col-span-8 lg:col-span-6 xl:col-span-4 lg:col-start-2 xl:col-start-2'">
                        <slot></slot>
                    </div>
                </div>
            </div>
            <div v-if="isConnected" class="md:hidden">
                <!-- Mobile navbar -->
                <div class="fixed bottom-0 left-0 right-0 p-2 py-2 bg-white border-t border-gray-200">
                    <div class="flex items-center justify-around">
                        <router-link :to="{ name: 'home'}">
                            <h4 class="mb-0">
                                <i class="fas fa-home"></i>
                            </h4>
                        </router-link>
                        <router-link :to="{ name: 'form.home'}" class="text-2xl default-text-color">
                            <h4 class="mb-0">
                                <i class="fas fa-plus-circle"></i>
                            </h4>
                        </router-link>
                        <router-link :to="{ name: 'user.product.list'}" class="text-2xl default-text-color">
                            <h4 class="mb-0">
                                <i class="fas fa-folder"></i>
                            </h4>
                        </router-link>
                        <router-link :to="{ name: 'user.update'}">
                            <h4 class="mb-0">
                                <i class="fas fa-user"></i>
                            </h4>
                        </router-link>
                    </div>
                </div>
            </div>

            <!-- Demo message -->
            <div v-if="onDemo && !this.hideDemoMessage && !isOnLocalhost" class="fixed z-20 w-1/3 p-5 bg-orange-300 md:w-1/3 lg:w-1/4 right-10 bottom-14 md:bottom-10 opacity-80 rounded-xl">
                <div class="flex items-center justify-between mb-1">
                    <div class="text-sm font-bold"><i class="mr-1 fas fa-wand-magic-sparkles"></i> Espace de démonstration</div>
                    <button class="text-sm duration-200 cursor-pointer opacity-40 hover:opacity-100 hover:text-red-600" @click="hideDemoMessage = true">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <p class="text-xs">Vous pouvez utiliser cette espace comme vous le souhaitez. Aucune donnée ne sera impactée.</p>
            </div>
        </sav-responsive-access-template>
    </div>
</template>
<script>
import SavResponsiveAccessTemplate from '../../../../components/SavResponsiveAccessTemplate.vue'
import apiService from '@/services/api.service'

export default {
    props: {
        title: {
            type: String,
        },
        backButton: {
            type: Boolean,
            default: true,
        },
        navigationBar: {
            type: Boolean,
            default: true,
        },
    },
    components: {SavResponsiveAccessTemplate},
    computed: {
        leftImage() {
            return this.$styleTool.templateImage(this.$route.name)
        },
        isConnected() {
            return this.$crypto.decrypt(localStorage.getItem('client_id')) ? true : false
        },
        isOnLocalhost() {
            return window.location.hostname == 'localhost'
        },
        onDemo() {
            return apiService.onDemo()
        }
    },
    data() {
        return {
            hideDemoMessage: false,
            langage: null,
            langs: []
        };
    },
    methods: {
        isSelect(routeName) {
            return this.$route.name.split(".")[0] == routeName || this.$route.name == routeName ? true : false;
        },
        getCssConf(name, defaultValue) {
            if (this.$companyTool.confFile() && this.$companyTool.confFile().style.css && this.$companyTool.confFile().style.css[name]) {
                return this.$companyTool.confFile().style.css[name]
            }
            return defaultValue
        },
        changeLangage(lang) {
            localStorage.setItem('langage', lang)
            location.reload()
        },
        async getAllLang() {
            let response = await apiService.post('getalllang', {})
            this.langs = response.data.posts.post
        }
    },
    async mounted() {
        document.title = this.$companyTool.keyname + " - Espace consommateur";
        document.body.style.backgroundColor = "#fff";
        document.body.style.color = "#000";

        // Colors
        var style = document.createElement("style")
        style.textContent = `
            .default-bg-color {background: ${this.getCssConf('defaultBgColor', '#111827')}}
            .default-text-color {color: ${this.getCssConf('defaultTextColor', 'rgb(17 24 39)')};}
            .default-bg-color-hover {background: ${this.getCssConf('defaultBgColorHover', '#000')};}
            .default-text-inside-color {color: ${this.getCssConf('textInsideColor', '#fff')};}
            .default-text-selected {color: ${this.getCssConf('defaultTextSelected', '#0EA5E9')};}
            .hover-default-text-selected:hover {color: ${this.getCssConf('hoverDefaultTextSelected', '#0e8bc3')};}
            .menu-text-unselected {color: ${this.getCssConf('menuTextUnselected', '#fff')};}
            .header-logo-height {height: ${this.getCssConf('headerLogoHeight', '40px')} !important;}
        `
        document.head.appendChild(style)

        // Favicon
        const favicon = document.getElementById("favicon")
        favicon.setAttribute("href", this.$companyTool.confFile().style.favicon || this.$companyTool.confFile().style.logo)

        // Lang
        await this.getAllLang()
        const lang = await this.$companyTool.getLang()
        this.langage = lang
    },
};
</script>
<style>
    .navigation {
        border-left: 5px solid white !important;
    }

    .navigation:hover {
        font-weight: 300 !important;
        color: black !important;
        background: rgb(248, 249, 250);
    }

    .navigation:hover .separator {
        background: black !important;
    }
</style>



// WEBPACK FOOTER //
// src/companies/default/views/template/SavTemplate.vue